module.exports = __webpack_public_path__ + "img/swift-glx-blanco-pop.72f61a0b.png";